module.exports = __webpack_public_path__ + "img/grasse_1.fea3e1c3.png";